import { CourseRepository } from '../../api/repository/course';

/** Titles for the IZ courses not yet known; a course that fails to load keeps no title. */
export async function courseTitles(ids: string[], known: Record<string, string>): Promise<Record<string, string>> {
  const missing = ids.filter((id, i) => id && !known[id] && ids.indexOf(id) === i);
  const found = await Promise.all(missing.map((id) => CourseRepository.fetchOne(id).then((course) => (course && course.title ? String(course.title) : ''), () => '')));
  const next = { ...known };
  missing.forEach((id, i) => { if (found[i]) next[id] = found[i]; });
  return next;
}
